import * as Yup from 'yup'
import * as moment from 'moment';
import 'moment/locale/es';

const localTime = moment().format('YYYY-MM-DD');
const today = localTime + "T00:00:00";

const ProfileSchema = Yup.object().shape( {
    tipo_doc_padre: Yup.string()
        .required('Requerido'),
    // dni: Yup.string()
    //     .required('Requerido')
    //     .min(8, 'Debe tener 8 dígitos')
    //     .max(8, 'Debe tener 8 dígitos'),
    dni: Yup.string()
        .when("tipo_doc_padre", {
            is: (tipo_doc_padre => {
                return ( tipo_doc_padre === '0101' ) ? true : false;
                }),
            then: Yup.string().required('Requerido')
                    .min(8, 'Debe tener 8 dígitos')
                    .max(8, 'Debe tener 8 dígitos'),
        })
        .when("tipo_doc_padre", {
            is: (tipo_doc_padre => {
                return ( tipo_doc_padre === '0102' || tipo_doc_padre === '0103' ) ? true : false;
                }),
            then: Yup.string().required('Requerido')
                    .min(12, 'Debe tener 12 caracteres')
                    .max(12, 'Debe tener 12 caracteres'),
        }),
    // nombre_completo: Yup.string()
    //     .required('Requerido'),



    // nombre: Yup.string()
    //     .required('Requerido')
    //     .trim('Requerido'),
    // apellido_paterno: Yup.string()
    //     .required('Requerido')
    //     .trim('Requerido'),
    // apellido_materno: Yup.string()
    //     .required('Requerido')
    //     .trim('Requerido'),




    
    nombre: Yup.string()
        .when("tipo_doc_padre", {
            is: (tipo_doc_padre => {
                return ( tipo_doc_padre === '0102' || tipo_doc_padre === '0103' || tipo_doc_padre === '0104' || tipo_doc_padre === '0105' ) ? true : false;
                }),
            then: Yup.string().required('Requerido').trim('Requerido'),
        }),
    
    apellido_paterno: Yup.string()
    .when("tipo_doc_padre", {
        is: (tipo_doc_padre => {
            return ( tipo_doc_padre === '0102' || tipo_doc_padre === '0103' || tipo_doc_padre === '0104' || tipo_doc_padre === '0105' ) ? true : false;
            }),
        then: Yup.string().required('Requerido').trim('Requerido'),
    }),

    apellido_materno: Yup.string()
        .when("tipo_doc_padre", {
            is: (tipo_doc_padre => {
                return ( tipo_doc_padre === '0102' || tipo_doc_padre === '0103' || tipo_doc_padre === '0104' || tipo_doc_padre === '0105' ) ? true : false;
                }),
            then: Yup.string().required('Requerido').trim('Requerido'),
        }),



    
    fecha_emision: Yup.date()
        .when("tipo_doc_padre", {
            is: (tipo_doc_padre => {
                return ( tipo_doc_padre === '0101' ) ? true : false;
                }),
            then: Yup.date().required("Requerido")
                            .max(today, "No puede ser mayor a hoy")
                            .typeError('Fecha incorrecta'),
        })
        .nullable(),

    // fecha_emision: Yup.date()
    //     .required('Requerido')
    //     .max(new Date() + 1, "No puede ser mayor a hoy")
    //     // .max(new Date(), "No puede ser mayor a hoy")
    //     .typeError('Fecha incorrecta'),
    //     // .nullable(),
    codigo_verificacion: Yup.string()
        .required('Requerido')
        .min(4, 'Debe tener 4 caracteres')
        .max(4, 'Debe tener 4 caracteres'),
    celular: Yup.string()
    .min(9, 'Debe tener 9 dígitos')
    .max(9, 'Debe tener 9 dígitos')
    // password: Yup.string("")
    //     .min(8, "Password must contain at least 8 characters")
    //     .required("Enter your password"),
    // confirmPassword: Yup.string("Enter your password")
    //     .required("Confirm your password")
    //     .oneOf([Yup.ref("password")], "Password does not match")
} )
// validate={ values => { 
        //     var errors = {}
        //     if ( !values.dni ) {
        //         errors.dni = 'El DNI es requerido'
        //     }
        //     else if ( values.dni.length !== 8 ) {
        //         errors.dni = 'DNI tiene que tener 8 dígitos'
        //     }
        //     else if (isNaN(values.dni)) {
        //         errors.dni = 'DNI tiene que ser numérico';
        //     }
            
        //     if ( !values.celular ) {
        //         errors.celular = 'Es requerido'
        //     }
        //     else if ( values.celular.length !== 9 ) {
        //         errors.celular = 'DNI tiene que tener 8 dígitos'
        //     }
        //     else if (isNaN(values.celular)) {
        //         errors.dni = 'DNI celular tiene que ser numérico';
        //     }
        //     return errors
        // } }
export default ProfileSchema